<!--
File: product-list-item.component.html
Project: catalog-cloud
File Created: Thursday, 17th February 2022 11:48:25
Author: Tomás Muniesa (tomas@cege.es)
-----
Last Modified:  Tuesday, 17th February 2026 5:41:28 pm
Modified By: Tomás (tomas@cege.es>)
-----
Copyright 2021 - 2022 Nousmedis, CeGe
-->

<div
  class="flex flex-row align-items-stretch overflow-hidden cursor-pointer hover-product"
  pDraggable
  (onDragStart)="dragItem($event)"
  (onDragEnd)="dragEnd($event)"
  (click)="sendProductToDetailView()"
  [class.selected]="selected"
  *ngIf="item"
>
  <div
    class="product-list-item__thumbnail flex-shrink-0"
    [lazyBg]="item.img"
  ></div>
  <div class="flex flex-column justify-content-center overflow-hidden product-list-item__content">
    <span
      class="text-overflow-ellipsis white-space-nowrap overflow-hidden product-list-item__name"
      ><b>{{ item.name }}</b></span
    >
    <span class="product-list-item__sku">Sku: {{ item.sku }}</span>
  </div>
</div>

<ng-template #itemDetails>
  <app-product-toolbar-product-details
    [item]="item"
  ></app-product-toolbar-product-details>
</ng-template>
